import { DownloadUserDbResult } from '@cf-shared/activation-codes-interface';

/** Drives the cursor-paginated downloadUserDb loop. Extracted as a pure
 *  function so it can be unit-tested without the full UserDb DI graph
 *  (and without transitively importing pouchdb-browser in Node). Throws
 *  if the server returns a structured error, or if the cursor fails to
 *  advance between pages (server bug); the partial DB is the caller's
 *  responsibility to roll back.
 */
export async function paginateDownloadUserDb(
  fetchPage: (lastSeenKey: string | undefined) => Promise<DownloadUserDbResult>,
  applyDoc: (doc: any) => Promise<unknown>,
): Promise<void> {
  let cursor: string | undefined;
  while (true) {
    const page = await fetchPage(cursor);
    if (page.error) {
      throw new Error(`downloadUserDb failed: ${page.error}`);
    }
    for (const doc of page.data ?? []) {
      await applyDoc(doc);
    }
    if (page.nextLastSeenKey == null) break;
    // guard against a server bug that returns the same cursor (or one we've
    // already processed) — without this the loop would never terminate
    if (page.nextLastSeenKey === cursor) {
      throw new Error(`downloadUserDb pagination stalled: server returned the same cursor (${cursor}) twice`);
    }
    cursor = page.nextLastSeenKey;
  }
}
